// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import { atualizarApartamento } from "../../../services/atualizarApartamentoService";

// --------------------- Import Interface ---------------------
import { Apartamento } from "../../../interfaces/Apartamento";

export const useAtualizarApto = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);

  const atualizarApto = async (
    aptoId: number | undefined,
    valuesAp: Apartamento
  ) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const atualizarApto = await atualizarApartamento(aptoId, valuesAp);

      if (atualizarApto) {
        setSuccess(true);
        setError(false);
      } else {
        setError(true);
        setSuccess(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return { atualizarApto, isLoading, isSuccess, error, success };
};
